<template>
    <v-col cols="12" md="4" ma-1>
        <v-card>
            <v-card-title class="title font-weight-black">
                Contact i-escape
            </v-card-title>

            <v-card-text>
               <p><a href="mailto:channels@i-escape.com">channels@i-escape.com</a> for channel management, iCal feeds and rate/availability updates</p>
               <p><a href="mailto:reservations@i-escape.com">reservations@i-escape.com</a> for the reservations department</p>
               <p><a href="mailto:help@i-escape.com">help@i-escape.com</a> for general help</p>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    /**
     * Display helpful information
     */
    export default {
        props:[],

        data: function() {
            return {
                dontShowAgain: false
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){
        },

        methods: {
            // Dont show again
        }
    }
</script>
